import React, { FC } from "react";

interface Props {
  description: string;
}

export const Description: FC<Props> = ({ description }) => {
  return (
    <div
      className="bg-purple-lighter p-4 sm:px-10 sm:py-5 rounded-20 break-words"
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};
